import React from "react";
import { useDashboardStats } from "services/input-core/dashboard/get-dashboard-stats";
import StatCard from "../StatCard";
import GridContainer from "components/UI/Grid/GridContainer";

const sizes = {
  xs: 12,
  sm: 6,
  md: 4,
  lg: 4,
};

const Stats: React.FC = () => {
  const { data: stats, isLoading: isStatsLoading } = useDashboardStats();

  return (
    <GridContainer>
      <StatCard
        {...sizes}
        color="warning"
        icon="business_center"
        statText="suppliers"
        value={stats?.supplierCount}
        content="view-suppliers"
        statLink={{ href: "/app/suppliers/list" }}
        isLoading={isStatsLoading}
        to="/app/suppliers/list"
      />

      <StatCard
        {...sizes}
        color="success"
        icon="groups"
        statText="workers"
        value={stats?.workerCount}
        content="view-workers"
        statLink={{ href: "/app/workers/list" }}
        isLoading={isStatsLoading}
        to="/app/workers/list"
      />

      <StatCard
        {...sizes}
        color="info"
        icon="folder"
        statText="sows"
        value={stats?.sowCount}
        content="view-sows"
        statLink={{ href: "/app/sows/list" }}
        isLoading={isStatsLoading}
        to="/app/sows/list"
      />
    </GridContainer>
  );
};

export default Stats;
